export default {
  navbar: {
    Home: "Home",
    Dashboard: "Dashboard",
    My: "My",
    Projects: "Projects",
    Admin: "Admin",

    ProjectList: "Project list",
    PlantProfile: "Plant profile",
    WeatherProfile: "Weather profile",
    PlantConfiguration: "Plant configuration",
    SiteObservation: "Site observation",
    PlantEquipmentSpecification: "Plant equipment specification",
    EquipmentSpecification: "Equipment specification",
    CoolingLoadProfile: "Cooling load profile",
    HeatingProfile: "Heating profile",
    Profile: "Profile",
    DataPreview: "Data preview",
    Analysis: "Analysis",
    GenerateReport: "Generate reports",

    Menus: "Menus",
    Objective: "Objective",
    PreRetrofit: "Pre retrofit",
    PosteRetrofit: "Post retrofit",

    Demo: "Demo"
  },
  ctrl: {
    Login: "Login",
    Logout: "Logout",
    Register: "Register",
    ModifyPassword: "Modify password",

    Language: "Language",
    UserGuide: "User guide",
    CreateProject: "Create project",
    Delete: "Delete",
    Cancel: "Cancel",
    Edit: "Edit",
    Copy: "Copy",
    Proceed: "Proceed",
    Save: "Save",
    Back: "Back",
    Next: "Next",
    Confirm: "Confirm",
    Close: "Close",
    Exit: "Exit",
    All: "All",
    Clear: "Clear",
    Yes: "Yes",
    No: "No",
    AddEquipment: "Add equipment",
    AddProfile: "Add profile",
    MultiSliding: "Multi-point sliding",
    GenerateReport: "Generate reports",
    DownloadReport: "Download report",

    MultiInput: "Multi-point input"
  },
  label: {
    UserName: "User name",
    Password: "Password",

    MultipleSelect: "Multiple",
    JobsiteName: "Jobsite name",
    JobsiteCity: "Jobsite city",
    BuildVertical: "Build vertical",
    DataCollectionMont: "Data collection month",
    CurrencyLabel: "Currency label",
    PeakTariff: "Peak hrs electricity tariff",
    OffPeakTariff: "Off-peak hrs electricity tariff",
    CapacityUnit: "Capacity unit",
    TemperatureUnit: "Temperature unit",

    ChillerType: "Chiller type",
    PumpingConfiguration: "Pumping configuration",
    Primary: "primary",

    Time: "Time",
    Hour: "Hour",
    Hours: "Hours",
    Day: "Day",
    Days: "Days",
    day: "day",
    Month: "Month",
    Months: "Months",
    Year: "Year",
    Years: "Years",

    RatedInputPower: "Rated input power",
    RatedCoolingCapacity: "Rated cooling capacity",
    MaxHz: "Max Hz",
    MinHz: "Min Hz",
    RatedHeatRejectionCapacity: "Rated heat rejection capacity",
    VFD: "VFD",
    isVFDInstalled: "Is a Variable Frequency Drive installed",
    EquipmentType: "Equipment type",
    AssetLabels: "Asset labels",
    UnitNumber: "Number of units (#)",
    PumpType: "Pump type",
    Age: "Age",
    DateCommissioned: "Date commissioned",
    Degradation: "Degradation rate",
    Brand: "Brand",
    Model: "Model",
    Remarks: "Remarks",
    RatedInputPower_100: "Rated input power at 100% (kW)",
    RatedInputPower_100_ct: "Rated input power at 100% per CT (kW)",
    RatedCoolingCapacity_100: "Rated cooling capacity at 100%",
    RatedHeatRejectionCapacity_100: "Rated heat rejection capacity at 100%",
    DesignChilledWaterLeavingTemp: "Design chilled water leaving temp",
    ActualChilledWaterLeavingTemp: "Actual chilled water leaving temp",
    DesignCondenserWaterEnteringTemp: "Design condenser water entering temp",
    TotalCellPerCoolingTower: "Total cell per cooling tower",
    ActualCondenserWaterEnteringTemp: "Actual condenser water entering temp",
    TotalCellPerDryCooler: "Total cell per dry cooler",
    DryCoolerType: "Dry cooler type",

    OutdoorDryBulbTemp: "Outdoor dry bulb temp",
    DesignCondenserSupplyTemp: "Design condenser water supply temp",

    RatedCapacity: "Rated capacity",
    RatedCapacityKW: "Rated capacity(kW)",
    EnergyType: "Input energy",

    ProfileName: "Profile name",
    OperatingPeriod: "Operating period",
    RunningMonths: "Running months",
    RunningDaysPerMonth: "Running days per month",
    ApplicableMonths: "Applicable months",
    BaselineMonth: "Baseline month",
    EstimatedMonth: "Estimated month",
    // BaseMonthCoolingLoad: "Cooling load in baseline month",
    DailyCoolingCapacity: "24h cooling capacity",
    LineChart: "Line chart",
    DataTable: "Data table",

    MonthlyCoolingLoad: "Monthly cooling load",
    CoolingLoad: "Cooling load",
    FullYearCoolingLoad: "Full year cooling load",
    WeightedAvg: "Weighted avg",
    Total: "Total",
    TotalOperatingLoad: "Total operating load",

    observationInfo: "Observation",
    observationPhoto: "Photo",
    photoMaximum6: "Maximum 6",

    SpaceApplication: "Application type",
    ChillerConfiguration: "Chiller configuration",
    BoilerConfiguration: "Boiler configuration",

    MaxHeatingCapacity: "Coldest month max heating capacity (kW)",
    EffectiveCapacity: "Coldest month effective capacity",
    BoilerEfficiency: "Boiler efficiency (AFUE)",
    DesignWaterTemperature: "Design hot water supply temperature",
    ActualWaterTemperature: "Actual hot water supply temperature",
    hotWaterTemp: "Required temperature for hot water supply",
    energyPrice: "Energy charges",
    EnergyCalorificValue: "Energy calorific value (CV)",
    EnergyCarbonIntensity: "Energy carbon intensity",

    PeakPeriod: "Peak period",
    OffPeakPeriod: "Off-peak period",
    ZeroHeatTemperature: "Temperature at zero heat demand",
    ZeroHotWaterTemperature: "Desired hot water temperature",
    ColdestTemperature: "Outdoor air temperature at maximum heating",
    BoilerUtilization: "Boiler utilization at coldest temperature",
    ColdestWater: "Coldest incoming water temperature",

    calculationMethod: "Method",
    SpaceSeatingProfile: "Space heating profile",

    HeatingLoadOAT: "Heating load kW and OAT profile",
    HeatingLoadWaterTemp: "Heating load kW and incoming cold water temperature profile",
    PredictedUtilization: "Predicted boiler utilization",
    ConfirmedUtilization: "User confirmed boiler utilization",

    WaterDemandPerDay: "Average water demand per person",
    UserNumber: "Number of occupants",
    liters: "liters",

    WeatherProfile: "Weather profile",

    EstimatePath: "Estimate path",
    CalculateMethod: "Calculate method",
    AvailableData: "Available data",

    ChillerModel: "Chiller model",

    RatedCondition: "Rated condition",
    WorkingCondition: "Working condition",

    DesignChilledWaterTemp: "Design chilled water supply temp",
    OutDoorDryBulbTemp: "Outdoor dry bulb temp",
    ChilledWaterSupplyTemp: "Chilled water supply temp",
    TowerApproachTemp: "Cooling tower approach temp",
    ChillerRunningNumber: "Number of chiller currently running (#)",
    RefChillerModel: "Reference chiller model",
    CoolingCapacityRange: "Cooling capacity range",

    AllRightsReserved: "All Rights Reserved."
  },
  placeholder: {
    PleaseInput: "Please input",
    SearchHere: "Search here",
    PleaseSelect: "Please select",
    TapEdit: "Tap to edit",
    NoDataExist: "No data exist"
  },
  msg: {
    NoProjectsExist: "No projects exist",
    DeleteProject: "Delete project",
    NoDeletePermission: "You don not have permission to delete this project",
    NoCreatePermission: "You don not have permission to create a project",
    Success: "Success",
    FailedRetry: "Failed! Please try again",
    SearchHere: "Search here",

    NoOperatePermission: "No permission to operate this project",
    NoChangePermission: "You can't save the project which is not created by yourself",
    JobsiteNameIsEmpty: "Jobsite name can not be empty",
    DeleteEquip: "Delete equipment",
    DeleteWarning: "Do you confirm to delete: ",
    DeleteProfile: "Delete profile",

    Warning: "Warning",
    UnsavedWarning: "Unsaved changes will be lost if you exit the current page.",
    SaveBeforeProceeding: "Do you want to save your changes before proceeding?",
    UnsavedAfterEstimate: "Unsaved data entered after the last estimate will be lost if you leave this page.",

    AssetLabelsIsEmpty: "Asset labels can not be empty",
    AssetLabelsAlreadyExists: "Asset labels already exists",
    ProfileInputTip: "Next, input cooling load details in above profiles before viewing below chart.",
    InfoItemsCanNotBeEmpty: "Info items can not be empty",
    ProfileAlreadyExist: "Profile name already exists",

    Saving: "Saving...",
    Generating: "Generating...",
    Loading: "Loading...",
    Deleting: "Deleting...",
    Downloading: "Downloading...",
    Estimating: "Estimating...",
    Analyzing: "Analyzing...",

    ReportConfidentialWarning:
      "The report is intended for customer presentation purposes ONLY. It contains proprietary information and must be handled in accordance with company policy. Please ensure that you understand and comply with all relevant confidentiality before downloading it to the device.",
    ReportConfidentialTitle: "Important Notice: Confidentiality Reminder",

    DeleteObservation: "Delete observation",
    DeletingFiles: "Deleting files...",
    CompressingFiles: "Compressing files...",
    UploadingFiles: "Uploading files...",
    NetworkError: "Network anomaly, operation failed",
    NetworkTimeout: "Network timeout! Please try again",

    RequestError: "Request error",
    LoginExpired: "Login expired",
    AccessDenied: "Access denied",
    ResourceNotExist: "The requested resource does not exist",
    ServerError: "Service error",
    GatewayError: "Gateway Error",
    ServiceUnavailable: "Service unavailable",
    UserNotExist: "User does not exist",
    WrongPassword: "Wrong password",
    NotActivate: "Account not activated",

    Over24HoursTips: "Total time over 24 hours",
    Over24HoursToast: "Total time of peaks and off-peak over 24 hours",
    OverMaxDayTips: "Total days over maximum: ",
    OverMaxDayToast: "Total day of weekday and weekend over total days in the month",
    OverWriteUtilization: "Overwrite all existing 'User confirmed boiler utilization' with 'Predicted boiler utilization' ?",

    SelectMethod: "Please select: Method",
    SelectApplicableMonths: "Please select: Applicable months",

    allPeakUseZero: "The User confirmed boiler utilization in Peak utilization cannot be all zeros.",
    allOffPeakUseZero: "The User confirmed boiler utilization in Off-peak utilization cannot be all zeros.",
    EnergyConsumptionHasZero: "All values in Energy consumption must not be zero.",
    saveWithZero: "The above issues will affect the accuracy of the calculations. Confirmed to proceed?",

    // OverrideWeatherData: "Weather datas already exists in the profiles.<br>Do you want to override the weather data using the selected city OAT?",
    OverrideWeatherData: "<br>Do you want to override the existing weather profile data using the newly selected city OAT?",
    CityChanged: "City has been changed from <strong>{curtCity}</strong> to <strong style='color: #1891f6;'>{newCity}</strong>.",

    ProfileNameIsEmpty: "Profile name can not be empty",
    SelectOperatingPeriod: "Please select operating period",
    NoApplicableMonths: "No applicable months in the current operating period",
    SelectReferModel: "Please select a reference model"
  },
  option: {
    Option_1: "Option 1",
    Option_2: "Option 2",
    Option_3: "Option 3",
    Option_4: "Option 4",
    Option_5: "Option 5",

    LARGE_OFFICE: "LARGE OFFICE",
    MEDIUM_OFFICE: "MEDIUM OFFICE",
    SMALL_OFFICE: "SMALL OFFICE",
    RESTAURANT: "RESTAURANT",
    HOSPITAL: "HOSPITAL",
    HOTEL: "HOTEL",
    MALL: "MALL",
    SCHOOL: "SCHOOL",
    EDUCATIONAL_INSTITUTIONS: "EDUCATIONAL INSTITUTIONS",
    RESIDENTIAL: "RESIDENTIAL",
    OTHERS: "OTHERS",

    Jan: "Jan",
    Feb: "Feb",
    Mar: "Mar",
    Apr: "Apr",
    May: "May",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Aug",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Dec",

    Weekday: "Weekday",
    Weekend: "Weekend",
    WholeWeek: "Whole week",

    WaterCooled: "Water-cooled",
    AirCooled: "Air-cooled",
    WaterCooled_AirCooled: "Water-cooled & air-cooled",

    ChilledWaterPrimary: "Chilled water primary system",
    ChilledWaterPrimarySecondary: "Chilled water primary - secondary system",
    CondenserWaterSys: "Condenser water system",

    CommonHeader: "Common header",
    Dedicated_1_1: "Dedicated 1-1",

    projectBackground: "Project background",

    chiller: "Chiller",
    pump: "Pump",
    coolingTower: "Cooling tower",
    piping: "Piping",
    others: "Others",
    dryCooler: "Dry cooler",
    boiler: "Boiler",

    wcCentri: "WC centri",
    wcScrew: "WC screw",
    wcRecip: "WC recip",
    wcScroll: "WC scroll",
    acScrew: "AC screw",
    acScroll: "AC scroll",
    acRecip: "AC recip",

    ChillerWaterPump: "Chilled water pump",
    ChillerWaterPumpPrimaryPump: "Chilled water pump - Primary pump",
    ChilledWaterPumpSecondaryPump: "Chilled water pump - Secondary pump",
    CondenserWaterPump: "Condenser water pump",

    Degradation_25: "0.25% per year - Good maintenance",
    Degradation_50: "0.50% per year - Average maintenance",
    Degradation_75: "0.75% per year - Below average maintenance",
    Degradation_100: "1.00% per year - Bad maintenance",

    CondenserWater: "Condenser water",

    SpaceCooling: "Space cooling",
    SpaceHeating: "Space heating",
    DomesticHotWater: "Domestic hot water",
    SpaceHeating_DomesticHotWater: "Space heating + domestic hotWater",

    GasFuel: "Gas fuel",
    LiquidFuel: "Liquid fuel",
    ElectricalEnergy: "Electrical energy",

    HeatingCalcMethod_1: "Boiler Capacity-Only Approach",
    HeatingCalcMethod_2: "Boiler Capacity with Energy Data Integration",

    dayHours: "Days & Hours",
    peakUtilization: "Peak utilization",
    offPeakUtilization: "Off-peak utilization",
    energyConsumption: "Energy consumption",

    heatingLoadPeak: "Heating load - Peak period",
    heatingLoadOffPeak: "Heating load - Off-peak period",
    incomingColdWaterTemp: "Incoming cold water temp",
    coldWaterTempPeak: "Incoming cold water temp - Peak period",
    coldWaterTempOffPeak: "Incoming cold water temp - Off-peak period",

    heatingLoadMonthly: "Monthly heating load",
    energyCharges: "Energy charges",
    co2Emissions: "CO₂ emissions",

    TabGeneralInfo: "General information",
    TabPeriod: "Period",
    TabLoadCapacity: "Load & Capacity",
    TabCoolingLoadRes: "Cooling load result",
    TabReferChillerCfg: "Reference chiller",
    TabPowerRes: "Power result",
    TabEstimateCoolingLoad: "Estimate cooling load",
    TabEstimatePower: "Estimate power",
    TabEstimate: "Estimate",
    TabWeightedPower: "Weighted power",

    TabRunningHours: "Running hours",
    TabEnergyConsumption: "Energy consumption",

    DryBulbTemp: "Dry bulb temp",
    WetBulbTemp: "Wet bulb temp",
    WaterTemp: "Water temp",
    MaxDryBulbTemp: "Max dry bulb temp",
    MinDryBulbTemp: "Min dry bulb temp",
    AvgDryBulbTemp: "Average dry bulb temp",
    MaxWetBulbTemp: "Max wet bulb temp",
    MinWetBulbTemp: "Min wet bulb temp",
    AvgWetBulbTemp: "Average wet bulb temp",
    PeakWaterTemp: "Peak water temp",
    OffPeakWaterTemp: "Off-peak water temp",

    PathA: "Based on cooling load",
    PathB: "Based on energy bill: 12M chiller usage",
    Method1: "1M hourly profile",
    // Method2: "Based on operating month's data",
    Method3: "12M hourly profile",

    Off: "Off",
    Peak: "Peak",
    OffPeak: "Off-peak",

    WeekdayPeak: "Weekday peak",
    WeekdayOffPeak: "Weekday off-peak",
    WeekendPeak: "Weekend peak",
    WeekendOffPeak: "Weekend off-peak",
    WholeWeekPeak: "Whole week peak",
    WholeWeekOffPeak: "Whole week off-peak",

    TabMonthlyRunning: "Monthly running",
    TabChillerAndPower: "Chiller & power",
    TabWeightedPower: "Weighted average power",

    TabChillerWorkingCondition: "Chiller working condition",
    TabWeightedAverageCoolingLoad: "Weighted average cooling load",
    TabWeightedAveragePower: "Weighted average power",

    TabRetrofitSetup: "Retrofit setup",
    TabEquipmentRated: "Equipment rated",
    TabProfileMapping: "Profile associated",
    TabRetrofitSummary: "Retrofit summary"
  },

  title: {
    // TabBaseMonth: "Cooling load in baseline month",
    TabCoolingLoadRes: "Weighted average cooling load",
    TabPowerRes: "Weighted average power",

    TabMonthlyRunning: "Monthly running (hrs/day)",
    TabChillerAndPower: "Chiller & power",
    TabWeightedPower: "Weighted average power",

    TabChillerWorkingCondition: "Chiller working condition",
    TabWeightedAverageCoolingLoad: "Weighted average cooling load",
    TabWeightedAveragePowerTitle: "Weighted average power",

    hr: "Time",
    period: "Period",
    chCount: "# chiller in operations",
    maxLoad: "Max nominal load",
    percent: "Operating load",
    capacity: "Total operating load",
    consumption: "Energy consumption",
    electricalLoad: "Electrical load",
    runningDays: "Running days",
    peakHours: "Peak hours",
    offPeakHours: "Off-peak hours",

    Configuration: "Configuration",
    ProfileList: "Profile list",

    PreRetrofitAnalysis: "Pre Retrofit Analysis",
    Power: "Power"
  }
}



// WEBPACK FOOTER //
// ./src/locale/index/en.js